import { render, staticRenderFns } from "./CountriesList.vue?vue&type=template&id=580480f8"
import script from "./CountriesList.vue?vue&type=script&lang=js"
export * from "./CountriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports